// Heuristic score 1 means the mailbox owner is mentioned in the email and either:
// the owner is the only recipient or the email contains an in-reply-to header (if the mail is a reply)
export const HEURISTIC_SCORE_1 = 1;

// Heuristic score 2 means that the email is marked as high importance and either:
// the owner is the only recipient or the owner is mentioned in the body of the email
export const HEURISTIC_SCORE_2 = 2;

export const HEURISTIC_SCORE_3 = 3;

export const PROACTIVE_DRAFT_HEURISTIC_SCORE_SET_ID = '41F28F13-83F4-4114-A584-EEDB5A6B0BFF';
export const PROACTIVE_DRAFT_HEURISTIC_SCORE = 'ProactiveDraftsHeuristicsScore';

// Number of proactive draft cards on the proactive drafts bar
export const NUMBER_OF_PROACTIVE_DRAFTS_TO_PARSE = 2;
